import { defineMessages } from '@cookbook/solid-intl'

// Split from the page's own messages so the router's title/description wiring does not pull the
// page chunk into the boot-critical bundle (same pattern as `about-page-routing.messages.en.js`).
// Phase 5 replaces these with per-location metadata.
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Find vacation rentals and places to stay, with local tips on where to stay and what to do.',
        id: 'LocationLandingPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Lodgr | Vacation Rentals',
        id: 'LocationLandingPage.titleMessage',
    }),
}
